module.exports = __webpack_public_path__ + "img/3136c33.jpg";